import {isEmpty} from 'lodash'

const initialState = {
    isFetchingPostData: false,

    isFetchingPutCourtUsed: false,
    isFetchingPutIncome: false,
    isFetchingPutChildren: false,
    isFetchingPutHardships: false,
    isFetchingUpdateHardship: false,
    isFetchingPutLowIncome: false,
    isFetchingPutChildSupport: false,
    isFetchingPutMandatoryChildSupport: false,
    isFetchingPutAdditionalChildSupport: false,
    isFetchingPutNonGuidelineOrder: false,
    isFetchingPutHealthCareExpenses: false,
    isFetchingPutEmploymentSearchOrder: false,
    isFetchingPutOtherOrders: false,

    isFetchingGetChildSupport: false,
    isFetchingDeleteChild: false,

    printout: -1,

    income: {
        petitioner_gmi: "",
        petitioner_nmi: "",

        respondent_gmi: "",
        respondent_nmi: "",

        other_gmi: "",
        other_nmi: "",

        incomeCheckbox: [],

        imputationCheckbox: [],

        income_b_number: "",
        income_b_text: "",
    },
    children: {
        children_a_text: "",
        children_b_plaintiff: "",
        children_b_respondent: "",
        children_b_other: "",
    },
    hardships: [],

    low_income: {
        lowincome: "-1",
    },

    child_support: {
        childCheckbox: [],

        base_child_support_date: "",

        childDetail: [{
            child_name: "",
            child_dob: "",
            monthly_amount: "",
            payable_name: "",
        }],

        payableCheckbox: [],
        base_child_support_other_text: "",
    },

    mandatory_child_support: {
        ChildPetitionerTotal: "",
        ChildPetitionerMonth: "",
        ChildRespondentTotal: "",
        ChildRespondentMonth: "",
        ChildOtherTotal: "",
        ChildOtherMonth: "",
        ChildCostSpecify: "",

        ReasonPetitionerTotal: "",
        ReasonPetitionerMonth: "",
        ReasonRespondentTotal: "",
        ReasonRespondentMonth: "",
        ReasonOtherTotal: "",
        ReasonOtherMonth: "",
        ReasonCostSpecify: "",
    },

    additional_child_support: {
        CostPetitionerTotal: "",
        CostPetitionerMonth: "",
        CostRespondentTotal: "",
        CostRespondentMonth: "",
        CostOtherTotal: "",
        CostOtherMonth: "",
        CostCostSpecify: "",

        TravelPetitionerTotal: "",
        TravelPetitionerMonth: "",
        TravelRespondentTotal: "",
        TravelRespondentMonth: "",
        TravelOtherTotal: "",
        TravelOtherMonth: "",
        TravelCostSpecify: "",
    },

    guidelineSupport: "-1",

    health_care_expenses: {
        healthCareExpenses: "0",

        health_care_expenses_available: [],

        health_care_expenses_not: [],

        health_care_expenses_c: "0",
    },

    employment_search_order: {
        employment_search_order_checkboxes: [],
        employment_search_order_text: "",
    },
    other_orders_text: "",
}



const childSupportInformationReducer = (state = initialState, action) => {
    switch (action.type) {

        case "REQUEST_POST_DATA":
            return { ...state, isFetchingPostData: true };
        case "SUCCESS_POST_DATA":
            return { ...state, isFetchingPostData: false };
        case "ERROR_POST_DATA":
            return { ...state, isFetchingPostData: false };
            

        case "REQUEST_PUT_COURT_USED":
            return { ...state, isFetchingPutCourtUsed: true };
        case "SUCCESS_PUT_COURT_USED":
            return {
                ...state,
                printout: action.payload.printOut,
                isFetchingPutCourtUsed: false,
            };
        case "ERROR_PUT_COURT_USED":
            return { ...state, isFetchingPutCourtUsed: false };




        case "REQUEST_PUT_INCOME":
            return { ...state, isFetchingPutIncome: true };
        case "SUCCESS_PUT_INCOME":
            return {
                ...state,
                isFetchingPutIncome: false,


                income: {
                    petitioner_gmi: action.payload.petitionerGmi,
                    petitioner_nmi: action.payload.petitionerNmi,

                    respondent_gmi: action.payload.respondentGmi,
                    respondent_nmi: action.payload.respondentNmi,

                    other_gmi: action.payload.otherGmi,
                    other_nmi: action.payload.otherNmi,

                    incomeCheckbox: action.payload.receivingTanf,

                    imputationCheckbox: action.payload.fl342IncomeAId,

                    income_b_number: action.payload.amount,
                    income_b_text: action.payload.perObject,
                }
            };
        case "ERROR_PUT_INCOME":
            return { ...state, isFetchingPutIncome: false };




        case "REQUEST_PUT_CHILDREN":
            return { ...state, isFetchingPutChildren: true };
        case "SUCCESS_PUT_CHILDREN":
            return {
                ...state,
                isFetchingPutChildren: false,

                children: {
                    children_a_text: action.payload.fl342ChildrenRelationshipADescription,
                    children_b_plaintiff: action.payload.petitionerPlaintiff,
                    children_b_respondent: action.payload.respondentDefendent,
                    children_b_other: action.payload.otherParent,
                }
            };
        case "ERROR_PUT_CHILDREN":
            return { ...state, isFetchingPutChildren: false };





        case "REQUEST_PUT_HARDSHIPS":
            return { ...state, isFetchingPutHardships: true };
        case "SUCCESS_PUT_HARDSHIPS":
            return {
                ...state,
                isFetchingPutHardships: false,
                hardships: action.payload.data,
            };
        case "ERROR_PUT_HARDSHIPS":
            return { ...state, isFetchingPutHardships: false };



        case "REQUEST_PUT_LOW_INCOME":
            return { ...state, isFetchingPutLowIncome: true };
        case "SUCCESS_PUT_LOW_INCOME":
            return {
                ...state,
                isFetchingPutLowIncome: false,

                low_income: {
                    lowincome: action.payload.adjustmentApplies,
                }
            };
        case "ERROR_PUT_LOW_INCOME":
            return { ...state, isFetchingPutLowIncome: false };




        case "REQUEST_PUT_CHILD_SUPPORT":
            return { ...state, isFetchingPutChildSupport: true };
        case "SUCCESS_PUT_CHILD_SUPPORT":
            return {
                ...state,
                isFetchingPutChildSupport: false,

                child_support: {
                    childCheckbox: action.payload.mustPay,

                    base_child_support_date: action.payload.supportDate,

                    childDetail: action.payload.childDetails,

                    payableCheckbox: action.payload.payable,
                    base_child_support_other_text: action.payload.payableOther,
                }
            };
        case "ERROR_PUT_CHILD_SUPPORT":
            return { ...state, isFetchingPutChildSupport: false };





        case "REQUEST_PUT_MANDATORY_CHILD_SUPPORT":
            return { ...state, isFetchingPutMandatoryChildSupport: true };
        case "SUCCESS_PUT_MANDATORY_CHILD_SUPPORT":
            return {
                ...state,
                isFetchingPutMandatoryChildSupport: false,

                mandatory_child_support: {
                    ChildPetitionerTotal: action.payload.ChildPetitionerTotal,
                    ChildPetitionerMonth: action.payload.ChildPetitionerMonth,
                    ChildRespondentTotal: action.payload.ChildRespondentTotal,
                    ChildRespondentMonth: action.payload.ChildRespondentMonth,
                    ChildOtherTotal: action.payload.ChildOtherTotal,
                    ChildOtherMonth: action.payload.ChildOtherMonth,
                    ChildCostSpecify: action.payload.ChildCostSpecify,
            
                    ReasonPetitionerTotal: action.payload.ReasonPetitionerTotal,
                    ReasonPetitionerMonth: action.payload.ReasonPetitionerMonth,
                    ReasonRespondentTotal: action.payload.ReasonRespondentTotal,
                    ReasonRespondentMonth: action.payload.ReasonRespondentMonth,
                    ReasonOtherTotal: action.payload.ReasonOtherTotal,
                    ReasonOtherMonth: action.payload.ReasonOtherMonth,
                    ReasonCostSpecify: action.payload.ReasonCostSpecify,
                }
            };
        case "ERROR_PUT_MANDATORY_CHILD_SUPPORT":
            return { ...state, isFetchingPutMandatoryChildSupport: false };





        case "REQUEST_PUT_ADDITIONAL_CHILD_SUPPORT":
            return { ...state, isFetchingPutAdditionalChildSupport: true };
        case "SUCCESS_PUT_ADDITIONAL_CHILD_SUPPORT":
            return {
                ...state,
                isFetchingPutAdditionalChildSupport: false,

                additional_child_support:{
                    CostPetitionerTotal: action.payload.CostPetitionerTotal,
                    CostPetitionerMonth: action.payload.CostPetitionerMonth,
                    CostRespondentTotal: action.payload.CostRespondentTotal,
                    CostRespondentMonth: action.payload.CostRespondentMonth,
                    CostOtherTotal: action.payload.CostOtherTotal,
                    CostOtherMonth: action.payload.CostOtherMonth,
                    CostCostSpecify: action.payload.CostCostSpecify,
            
                    TravelPetitionerTotal: action.payload.TravelPetitionerTotal,
                    TravelPetitionerMonth: action.payload.TravelPetitionerMonth,
                    TravelRespondentTotal: action.payload.TravelRespondentTotal,
                    TravelRespondentMonth: action.payload.TravelRespondentMonth,
                    TravelOtherTotal: action.payload.TravelOtherTotal,
                    TravelOtherMonth: action.payload.TravelOtherMonth,
                    TravelCostSpecify: action.payload.TravelCostSpecify,
            }
        };
        case "ERROR_PUT_ADDITIONAL_CHILD_SUPPORT":
            return { ...state, isFetchingPutAdditionalChildSupport: false };






        case "REQUEST_PUT_NON_GUIDELINE_ORDER":
            return { ...state, isFetchingPutNonGuidelineOrder: true };
        case "SUCCESS_PUT_NON_GUIDELINE_ORDER":
            return {
                ...state,
                isFetchingPutNonGuidelineOrder: false,

                guidelineSupport: action.payload.nonGuideline,
            };
        case "ERROR_PUT_NON_GUIDELINE_ORDER":
            return { ...state, isFetchingPutNonGuidelineOrder: false };





        case "REQUEST_PUT_HEALTH_CARE_EXPENSES":
            return { ...state, isFetchingPutHealthCareExpenses: true };
        case "SUCCESS_PUT_HEALTH_CARE_EXPENSES":
            return {
                ...state,
                isFetchingPutHealthCareExpenses: false,

                health_care_expenses:{
                healthCareExpenses: action.payload.healthSelectOption,

                health_care_expenses_available: action.payload.healthInsuranceCoverage,

                health_care_expenses_not: action.payload.insuranceNotAvailable,

                health_care_expenses_c: action.payload.partyProviding,
            }};
        case "ERROR_PUT_HEALTH_CARE_EXPENSES":
            return { ...state, isFetchingPutHealthCareExpenses: false };




        case "REQUEST_PUT_EMPLOYMENT_SEARCH_ORDER":
            return { ...state, isFetchingPutEmploymentSearchOrder: true };
        case "SUCCESS_PUT_EMPLOYMENT_SEARCH_ORDER":
            return {
                ...state,
                isFetchingPutEmploymentSearchOrder: false,

                employment_search_order:{
                employment_search_order_checkboxes: action.payload.fl342IncomeAId,
                employment_search_order_text: action.payload.termCondition,
            }};
        case "ERROR_PUT_EMPLOYMENT_SEARCH_ORDER":
            return { ...state, isFetchingPutEmploymentSearchOrder: false };




        case "REQUEST_PUT_OTHER_ORDERS":
            return { ...state, isFetchingPutOtherOrders: true };
        case "SUCCESS_PUT_OTHER_ORDERS":
            return {
                ...state,
                isFetchingPutOtherOrders: false,
                other_orders_text: action.payload.otherOrderDescription,

            };
        case "ERROR_PUT_OTHER_ORDERS":
            return { ...state, isFetchingPutOtherOrders: false };





        case "REQUEST_GET_CHILD_SUPPORT":
            return { ...state, 
                isFetchingPostData: false,

                isFetchingPutCourtUsed: false,
                isFetchingPutIncome: false,
                isFetchingPutChildren: false,
                isFetchingPutHardships: false,
                isFetchingPutLowIncome: false,
                isFetchingPutChildSupport: false,
                isFetchingPutMandatoryChildSupport: false,
                isFetchingPutAdditionalChildSupport: false,
                isFetchingPutNonGuidelineOrder: false,
                isFetchingPutHealthCareExpenses: false,
                isFetchingPutEmploymentSearchOrder: false,
                isFetchingPutOtherOrders: false,
            
                isFetchingGetChildSupport: true,
            
                printout: -1,
            
                income: {
                    petitioner_gmi: "",
                    petitioner_nmi: "",
            
                    respondent_gmi: "",
                    respondent_nmi: "",
            
                    other_gmi: "",
                    other_nmi: "",
            
                    incomeCheckbox: [],
            
                    imputationCheckbox: [],
            
                    income_b_number: "",
                    income_b_text: "",
                },
                children: {
                    children_a_text: "",
                    children_b_plaintiff: "",
                    children_b_respondent: "",
                    children_b_other: "",
                },
                hardships: [
                ],
            
                low_income: {
                    lowincome: "-1",
                },
            
                child_support: {
                    childCheckbox: [],
            
                    base_child_support_date: "",
            
                    childDetail: [{
                        child_name: "",
                        child_dob: "",
                        monthly_amount: "",
                        payable_name: "",
                    }],
            
                    payableCheckbox: [],
                    base_child_support_other_text: "",
                },
            
                mandatory_child_support: {
                    ChildPetitionerTotal: "",
                    ChildPetitionerMonth: "",
                    ChildRespondentTotal: "",
                    ChildRespondentMonth: "",
                    ChildOtherTotal: "",
                    ChildOtherMonth: "",
                    ChildCostSpecify: "",
            
                    ReasonPetitionerTotal: "",
                    ReasonPetitionerMonth: "",
                    ReasonRespondentTotal: "",
                    ReasonRespondentMonth: "",
                    ReasonOtherTotal: "",
                    ReasonOtherMonth: "",
                    ReasonCostSpecify: "",
                },
            
                additional_child_support: {
                    CostPetitionerTotal: "",
                    CostPetitionerMonth: "",
                    CostRespondentTotal: "",
                    CostRespondentMonth: "",
                    CostOtherTotal: "",
                    CostOtherMonth: "",
                    CostCostSpecify: "",
            
                    TravelPetitionerTotal: "",
                    TravelPetitionerMonth: "",
                    TravelRespondentTotal: "",
                    TravelRespondentMonth: "",
                    TravelOtherTotal: "",
                    TravelOtherMonth: "",
                    TravelCostSpecify: "",
                },
            
                guidelineSupport: "-1",
            
                health_care_expenses: {
                    healthCareExpenses: "0",
            
                    health_care_expenses_available: [],
            
                    health_care_expenses_not: [],
            
                    health_care_expenses_c: "0",
                },
            
                employment_search_order: {
                    employment_search_order_checkboxes: [],
                    employment_search_order_text: "",
                },
                other_orders_text: "", };
        case "SUCCESS_GET_CHILD_SUPPORT":
            return {
                ...state,

                printout: action.payload.data.printout,

                income: {
                    petitioner_gmi: action.payload.data.income.petitioner_gmi,
                    petitioner_nmi: action.payload.data.income.petitioner_nmi,

                    respondent_gmi: action.payload.data.income.respondent_gmi,
                    respondent_nmi: action.payload.data.income.respondent_nmi,

                    other_gmi: action.payload.data.income.other_gmi,
                    other_nmi: action.payload.data.income.other_nmi,

                    incomeCheckbox: [action.payload.data.income.incomeCheckbox],

                    imputationCheckbox: [action.payload.data.income.imputationCheckbox],

                    income_b_number: action.payload.data.income.income_b_number,
                    income_b_text: action.payload.data.income.income_b_text,
                },
                children: {
                    children_a_text: action.payload.data.children.children_a_text,
                    children_b_plaintiff: action.payload.data.children.children_b_plaintiff,
                    children_b_respondent: action.payload.data.children.children_b_respondent,
                    children_b_other: action.payload.data.children.children_b_other,
                },
                hardships: action.payload.data.hardships,

                low_income: {
                    lowincome: action.payload.data.low_income.lowincome,
                },

                child_support: {
                    childCheckbox: action.payload.data.child_support.childCheckbox,

                    base_child_support_date: action.payload.data.child_support.base_child_support_date,

                    childDetail: action.payload.data.child_support.childDetail,

                    payableCheckbox: action.payload.data.child_support.payableCheckbox,
                    base_child_support_other_text: action.payload.data.child_support.base_child_support_other_text,
                },

                mandatory_child_support: {
                    ChildPetitionerTotal: action.payload.data.mandatory_child_support.ChildPetitionerTotal,
                    ChildPetitionerMonth: action.payload.data.mandatory_child_support.ChildPetitionerMonth,
                    ChildRespondentTotal: action.payload.data.mandatory_child_support.ChildRespondentTotal,
                    ChildRespondentMonth: action.payload.data.mandatory_child_support.ChildRespondentMonth,
                    ChildOtherTotal: action.payload.data.mandatory_child_support.ChildOtherTotal,
                    ChildOtherMonth: action.payload.data.mandatory_child_support.ChildOtherMonth,
                    ChildCostSpecify: action.payload.data.mandatory_child_support.ChildCostSpecify,
            
                    ReasonPetitionerTotal: action.payload.data.mandatory_child_support.ReasonPetitionerTotal,
                    ReasonPetitionerMonth: action.payload.data.mandatory_child_support.ReasonPetitionerMonth,
                    ReasonRespondentTotal: action.payload.data.mandatory_child_support.ReasonRespondentTotal,
                    ReasonRespondentMonth: action.payload.data.mandatory_child_support.ReasonRespondentMonth,
                    ReasonOtherTotal: action.payload.data.mandatory_child_support.ReasonOtherTotal,
                    ReasonOtherMonth: action.payload.data.mandatory_child_support.ReasonOtherMonth,
                    ReasonCostSpecify: action.payload.data.mandatory_child_support.ReasonCostSpecify,
                },

                additional_child_support: {
                    CostPetitionerTotal: action.payload.data.additional_child_support.CostPetitionerTotal,
                    CostPetitionerMonth: action.payload.data.additional_child_support.CostPetitionerMonth,
                    CostRespondentTotal: action.payload.data.additional_child_support.CostRespondentTotal,
                    CostRespondentMonth: action.payload.data.additional_child_support.CostRespondentMonth,
                    CostOtherTotal: action.payload.data.additional_child_support.CostOtherTotal,
                    CostOtherMonth: action.payload.data.additional_child_support.CostOtherMonth,
                    CostCostSpecify: action.payload.data.additional_child_support.CostCostSpecify,
            
                    TravelPetitionerTotal: action.payload.data.additional_child_support.TravelPetitionerTotal,
                    TravelPetitionerMonth: action.payload.data.additional_child_support.TravelPetitionerMonth,
                    TravelRespondentTotal: action.payload.data.additional_child_support.TravelRespondentTotal,
                    TravelRespondentMonth: action.payload.data.additional_child_support.TravelRespondentMonth,
                    TravelOtherTotal: action.payload.data.additional_child_support.TravelOtherTotal,
                    TravelOtherMonth: action.payload.data.additional_child_support.TravelOtherMonth,
                    TravelCostSpecify: action.payload.data.additional_child_support.TravelCostSpecify,
                },

                guidelineSupport: action.payload.data.guidelineSupport,

                health_care_expenses: {
                    healthCareExpenses: action.payload.data.health_care_expenses.healthCareExpenses,

                    health_care_expenses_available: [action.payload.data.health_care_expenses.health_care_expenses_available],

                    health_care_expenses_not: [action.payload.data.health_care_expenses.health_care_expenses_not],

                    health_care_expenses_c: action.payload.data.health_care_expenses.health_care_expenses_c,
                },

                employment_search_order: {
                    employment_search_order_checkboxes: [action.payload.data.employment_search_order.employment_search_order_checkboxes],
                    employment_search_order_text: action.payload.data.employment_search_order.employment_search_order_text,
                },

                other_orders_text: action.payload.data.other_orders_text,

                isFetchingGetChildSupport: false
            };
        case "ERROR_GET_CHILD_SUPPORT":
            return { ...state, isFetchingGetChildSupport: false };


            case "REQUEST_DELETE_CHILD":
                return { ...state, isFetchingDeleteChild: true };
              case "SUCCESS_DELETE_CHILD":
                return {
                  ...state,
                  isFetchingDeleteChild: false,

                  child_support: {
                    childCheckbox: action.payload.mustPay,

                    base_child_support_date: action.payload.supportDate,

                    childDetail: isEmpty(action.payload.data) ? initialState.childDetail: action.payload.data,
                    // action.payload.childDetails,

                    payableCheckbox: action.payload.payable,
                    base_child_support_other_text: action.payload.payableOther,
                }
                //   installmentPayments: isEmpty(action.payload.data) ? initialState.installmentPayments: action.payload.data,
                };
              case "ERROR_DELETE_CHILD":
                return { ...state, isFetchingDeleteChild: false };


        default:
            return state;
    }

}

export default childSupportInformationReducer